import getExtensibilityState from '../store/getExtensibilityState';

export function getUiLessAddinRunningForEMO(): string {
    return getExtensibilityState()?.uiLessAddinRunningForEMO;
}
